export const DEFAULT_LOCATION = {
    name: 'Cargomatic',
    address: '211 E Ocean Blvd, Long Beach, CA 90802, USA',
};
